import { GROUP_RECEIVED } from './actions'

const reducer = (state = {}, action) => {
  const { type, payload } = action
  switch (type) {
    case GROUP_RECEIVED:
      if (payload == null) throw new Error('No group')
      return payload
    default:
      return state
  }
}

export const getGroup = state => state.group
export const getGroupMembers = state => state.group.member

export default reducer



// WEBPACK FOOTER //
// ./src/Group/ducks.js